<img [src]="photo.fileBase64" style="width: 100%; max-height: 260px" />
